import React from 'react';
import PropTypes from 'prop-types';

import { EventLink } from '@atlas/routing';
import { Icon, Label } from '@atlas/ui';

const EmptyOutcomesRow = ({ eventId }) => (
  <EventLink className="other-markets" eventId={eventId}>
    <div className="other-markets-content">
      <Label message="other_markets" />
      <Icon className="icon-m-arrow-right" name="m-arrow-right" />
    </div>
  </EventLink>
);

EmptyOutcomesRow.propTypes = {
  eventId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default EmptyOutcomesRow;
